const squareDashboard = "https://square.site";
const squareStoreDashboard = "https://square.online";
const squarespaceDashboard = "https://account.squarespace.com/";
const shopifyDashboard = 'https://accounts.shopify.com/store-login';
const indiecommerce2Dashboard = (website) => {
    const prefix = website.startsWith('http://') || website.startsWith('https://') ? '' : 'https://';
    return `${prefix}${website}/admin/dashboard`;
};
export { squareDashboard, squareStoreDashboard, squarespaceDashboard, shopifyDashboard, indiecommerce2Dashboard };
